import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { IBaseStore } from '@/store/types'
import {
    IBatch,
    IBatchListFiltersDTO,
    IStatementsBatchDashboardStatistics,
    IStatementsBatchStatisticsDTO
} from '@zunta/configurations'
import Api from '@/api'

export interface IBatchState {
    batchList: IBatch[];
    total: number;
    statementBatchStatistics: IStatementsBatchStatisticsDTO | null;
    statementsBatchDashboardStatistics: IStatementsBatchDashboardStatistics | null;
    selectedBatch: IBatch | null;
}

export interface IBatchStore extends IBaseStore {
    state: IBatchState
}

@Module({
    name: 'batch',
    namespaced: true
})
export class BatchModule extends VuexModule {
    batchList: IBatch[] = []
    total: number = 0
    statementBatchStatistics: IStatementsBatchStatisticsDTO | null = null
    statementsBatchDashboardStatistics: IStatementsBatchDashboardStatistics | null = null
    selectedBatch: IBatch | null = null
    showBatchAlerts: boolean = false

    @Mutation
    UPDATE_BATCH_LIST (list: IBatch[]) {
        this.batchList = list
    }

    @Mutation
    UPDATE_TOTAL (total: number) {
        this.total = total
    }

    @Mutation
    UPDATE_SELECTED_BATCH (batch: IBatch | null) {
        this.selectedBatch = batch
    }

    @Mutation
    UPDATE_STATEMENTS_BATCH_DASHBOARD_STATISTICS (statistics: IStatementsBatchDashboardStatistics | null) {
        this.statementsBatchDashboardStatistics = statistics
    }

    @Action
    async getBatchListByFilters (filters: IBatchListFiltersDTO) {
        const { batchList, total } = await Api.statement.getBatchListByFilters(filters)
        if (batchList) {
            this.UPDATE_BATCH_LIST(batchList)
            this.UPDATE_TOTAL(total)
        }
    }

    @Mutation
    UPDATE_BATCH_STATEMENTS_STATISTICS (batchStatementsStatistics: IStatementsBatchStatisticsDTO | null) {
        this.statementBatchStatistics = batchStatementsStatistics
    }

    @Mutation
    UPDATE_BATCH_ALERT (value: boolean) {
      this.showBatchAlerts = value
    }

    @Action
    async deleteBatch (batchId: number | string): Promise<any> {
        return Api.statement.deleteBatchById(batchId)
    }

    @Action
    async fetchBatch (batchId: number | string) {
        const batch = await Api.statement.getBatchById(batchId)
        this.UPDATE_SELECTED_BATCH(batch)
    }

    @Action
    async confirmMissingPayerCharges (batchId: number) {
        await Api.statement.confirmMissingPayerCharges(batchId)
    }

    @Action
    async getStatementsBatchDashboardStatistics (batchId: number | string) {
        const statistics: IStatementsBatchDashboardStatistics = await Api.statistics.getBatchStatementsDashboardStatistics(batchId)
        this.UPDATE_STATEMENTS_BATCH_DASHBOARD_STATISTICS(statistics)
    }

    @Action
    async getStatementBatchStatistics (batchId: number | string) {
        const statistics = await Api.statistics.getBatchStatementsStatistics(batchId)
        this.UPDATE_BATCH_STATEMENTS_STATISTICS(statistics)
    }

    @Action
    resetStatistics () {
        this.UPDATE_BATCH_STATEMENTS_STATISTICS(null)
        this.UPDATE_STATEMENTS_BATCH_DASHBOARD_STATISTICS(null)
    }

    @Action
    async replaceBatchUser (payload: any) {
        const { facilityId, userId, data } = payload
        await Api.statement.replaceBatchUser(facilityId, userId, data)
    }

    @Action
    toggleBatchAlert (value: boolean) {
      this.UPDATE_BATCH_ALERT(value)
    }
}
